import { Heading, Paragraph } from '@audio-network/componentlibrary'
import { usePlayer } from '@audio-network/player'
import { useTranslation } from 'next-i18next'
import { useRef } from 'react'

import isDateOlderThan from '@/utils/formatting/isDateOlderThan'

import Spotlight from '../../../shared/Spotlight/Spotlight'
import { TrackInfoSpotlightProps } from './TrackInfoSpotlight.types'

const SPOTLIGHT_NAME = 'track-info'

export default function TrackInfoSpotlight({
	user,
}: TrackInfoSpotlightProps): JSX.Element {
	const { t } = useTranslation(['spotlights'])

	const { currentTrack } = usePlayer()
	const describesRef = useRef<string>('')

	// Set the describes selector only once when currentTrack is first available
	if (currentTrack?.id && !describesRef.current) {
		describesRef.current = `[data-track-info="${currentTrack.id}"]`
	}

	const describes = describesRef.current

	if (!user || !describes) return null

	// New users see AddToFavouritesSpotlight first; this one only after the first week.
	const isStillInFirstWeek = !isDateOlderThan(user.createdDate, 7)
	if (isStillInFirstWeek) return null

	return (
		<Spotlight describes={describes} name={SPOTLIGHT_NAME}>
			<Heading level={2} size="XS">
				{t('search-page.track-info-title')}
			</Heading>
			<Paragraph>{t('search-page.track-info-description')}</Paragraph>
		</Spotlight>
	)
}
